import "@/CSS/site.css";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";
import VueNumerals from "vue-numerals";
import router from "@/shared/services/routing/router.js";
import i18nOptions from "@/shared/services/i18n/i18nOptions.js";
import Loading from 'vue-loading-overlay';
import VueI18n from "vue-i18n";
import Toasted from "vue-toasted";
import Multiselect from "vue-multiselect";
import filters from "@/shared/utils/appFilters";
import Vuetify from "vuetify";
import axios from "axios";
import pendoUtils from '@/shared/utils/pendoUtils.js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import DynamicTable from '@/shared/components/Common/DynamicTableComponent.vue';
import PaginationComponent from '@/shared/components/Common/PaginationComponent.vue';
import ModalComponent from '@/shared/components/common/Modal/ModalComponent.vue';
import ConfirmationComponent from '@/shared/components/common/ConfirmationComponent.vue';
import IrisConfirm from '@/shared/components/common/IrisConfirm.vue';
import "bootstrap";
import 'nprogress/nprogress.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "@mdi/font/css/materialdesignicons.min.css";
import "vuetify/dist/vuetify.min.css";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "@/CSS/jll.dx.scheme.css";
import "@/CSS/jll.bootstrap.css";
import "@/CSS/post.css";
import "@/CSS/bootstrapOverwrites.css";
import "@/CSS/jll-palette.css";
import appVue from "@/shared/components/App.vue";

Vue.component("multiselect", Multiselect);
Vue.component('dynamic-table-component', DynamicTable)
Vue.component('pagination-component', PaginationComponent)
Vue.component('modal-component', ModalComponent)
Vue.component('confirmation-component', ConfirmationComponent)
Vue.component('iris-confirm', IrisConfirm)

//////////////////////////////////////////////////////////////

Vue.use(VueNumerals); // default locale is 'en'

const VueInputMask = require("vue-inputmask").default;
Vue.use(VueInputMask);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(Toasted, { iconPack: "mdi", duration: 5000, keepOnHover: true });
Vue.use(Loading, { color: "red", width: 48, height: 48 });
Vue.use(Vuetify);

const langCode = localStorage.getItem("LazLangCode").value;
if (langCode != null) {
    store.dispatch('SetLangCode', langCode);
    console.info("LangCode Restored - " + langCode);
}

const i18n = new VueI18n(i18nOptions);
const vuetify = new Vuetify({});


const initPendo = (user, instance, country) => {
    axios
        .get('api/Configuration/GetPendoApiKey')
        .then((response) => {
            const pendoApiKey = response != null && response != undefined ? response.data : null;
            console.log(response)
            if (pendoApiKey) {
                pendoUtils.load(pendoApiKey);
                pendoUtils.initialize(user, instance, country);
            } else {
                console.error('Could not retrieve Pendo apikey from keyvault');
            }
        })
        .catch(() => {
            console.error('Could not retrieve Pendo apikey from keyvault');
        });
};

const initAppInsights = (router) => {
    axios
        .get('api/Configuration/GetInstrumentationKey')
        .then((response) => {
            const instrumentationKey = response != null && response != undefined ? response.data : null;
            console.log(response)
            const appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: instrumentationKey,
                    router,
                    enableAutoRouteTracking: true
                }, 
            });
            appInsights.loadAppInsights();
            appInsights.trackPageView();
            // Manually call trackPageView to establish the current user/session/pageview
        })
        .catch(() => {
            console.error('Could not retrieve App Insights Instrumentation apikey from keyvault');
        });
}


/* APP */
var vm = new Vue({
    el: "#app-root",
    i18n,
    store,
    pendoUtils,
    filters,
    router: router,
    vuetify,
    render: (h) => h(appVue),
    created: function () {
        console.log("[evt - app created]: Iris is alive");
        var isAuth = this.$store.getters.isAuthenticated;
        if (!isAuth) {
            console.log("[evt - app created]: User not authenticated");
        } else {
            let country = this.$store.getters.country
            initPendo(this.$store.getters.UserName, this.$store.getters.instance, country);
            initAppInsights(router)
            console.log("[evt - app created]: User authenticated");
        }
        console.log("[evt - app created]: End function");
    },
});


export { vm }
